angular.module('formValidation', []).
directive('showErrors', function() {

	/*
  		CTRL:
		force error to show up: 	$scope.$broadcast('show-errors-check-validity');
		reset error: 				$scope.$broadcast('show-errors-reset');

		BASIC HTML:
		<form name="userForm">
		    <div class="form-group" show-errors>
		      <input type="text" class="form-control" name="name" ng-model="user.name" required />
		      <p class="help-block" ng-if="userForm.name.$error.required">The user's name is required</p>
		    </div>
		    <div class="form-group" show-errors>
		      <input type="email" class="form-control" name="email" ng-model="user.email" required />
		      <p class="help-block" ng-if="userForm.email.$error.required">The user's email is required</p>
		      <p class="help-block" ng-if="userForm.email.$error.email">The email address is invalid</p>
		    </div>
		 </form>

  	*/

	return {
		restrict: 'A',
		require: '^form',
		link: function(scope, el, attrs, formCtrl) {

			// find the text box element, which has the 'name' attribute
			var inputEl = el[0].querySelector("[name]");

			// convert the native text box element to an angular element
			var inputNgEl = angular.element(inputEl);

			// oget the name property
			var inputName = inputNgEl.attr('name');

			// only apply the has-error class after the user leaves the text box
			inputNgEl.bind('blur', function() {
				el.toggleClass('has-error', formCtrl[inputName].$invalid);
			});

			// force the error class to show up
			scope.$on('show-errors-check-validity', function() {
				el.toggleClass('has-error', formCtrl[inputName].$invalid);
			});

			// reset the error class
			scope.$on('show-errors-reset', function() {
				$timeout(function() {
					el.removeClass('has-error');
				}, 0, false);
			});

		}
	};
});